
import { uploadMultipartFile } from "../../../api/authentication/storageApi";

function findModelElementByUploadId(editor, uploadId) {
  const root = editor.model.document.getRoot();
  const range = editor.model.createRangeIn(root);

  for (const value of range.getWalker()) {
    const item = value.item;

    if (
      value.type === "elementStart" &&
      (item.is("element", "imageBlock") || item.is("element", "imageInline"))
    ) {
      if (item.getAttribute("uploadId") === uploadId) {
        return item;
      }
    }
  }
  return null;
}

export const UploadAdapterPlugin = (editor, conversationId) => {
  editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
    return createUploadAdapter(loader, conversationId, editor);
  };
};

const createUploadAdapter = (loader, conversationId, editor) => {
  return {
    upload: async () => {
      try {
        const file = await loader.file;

        const controller = new AbortController();
        const savedImageRes = await uploadMultipartFile({
          file,
          bucket: "notification",
          signal: controller.signal,
        });

        const imageLocation = savedImageRes?.location;

        if (imageLocation) {
          return {
            default: imageLocation,
          };
        }

        throw new Error("Upload failed. Image not inserted.");
      } catch (error) {
        console.error("UploadAdapter error:", error);
        throw new Error("Upload failed. Image not inserted.");
      }
    },

    abort: () => {
      const modelImg = findModelElementByUploadId(editor, loader.id);
      if (modelImg) {
        editor.model.change((writer) => {
          writer.setAttribute("uploadStatus", "aborted", modelImg);
        });
      }
    },
  };
};
